export default "/images/artist5.png?00e7af7d19f83f43892f2ee31825c79d";